import { render, staticRenderFns } from "./PrintQueueHistory.vue?vue&type=template&id=0c99a85a&"
import script from "./PrintQueueHistory.vue?vue&type=script&lang=js&"
export * from "./PrintQueueHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports